import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ObjectAssociationsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ObjectAssociations",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.72 19.21v-1.47a.29.29 0 0 0-.29-.29H12.91v7.31h11.53c.16 0 .29-.14.3-.3v-1.5c0-.06.01-.11.05-.16.08-.14.26-.18.4-.1l4.67 2.98.08.07c.09.14.07.32-.07.42l-4.67 3.46c-.05.04-.12.06-.19.07-.16 0-.29-.14-.29-.3v-1.49a.29.29 0 0 0-.29-.29H10.54c-.24 0-.43-.19-.43-.43v-9.82H2.54c-.28.02-.53-.2-.54-.48v-1.8c0-.28.23-.51.51-.51h7.59V4.8c0-.23.18-.42.41-.43h13.91a.31.31 0 0 0 .28-.29v-1.5c0-.06.01-.11.05-.16.09-.14.27-.18.41-.09l4.63 2.98s.06.04.08.07c.09.14.07.32-.07.42l-4.67 3.46s-.11.07-.18.07c-.17 0-.3-.13-.3-.3V7.55c0-.14-.1-.25-.23-.28H12.9v7.31h11.52c.16 0 .29-.14.29-.3v-1.51c0-.06.01-.11.05-.16.09-.14.27-.18.41-.09l4.63 2.98s.06.04.08.07c.09.14.07.32-.07.42l-4.67 3.46s-.11.07-.18.07a.3.3 0 0 1-.26-.3Z"
    })
  }));
};